export default __webpack_public_path__ + "static/media/SIMBA_Market_logo_opti1.416859de.png";